import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import shortid from 'shortid'

// DON NOT REMOVE the comments around 'import style.scss'
// ###STYLE_REPLACEMENT_START###
import './style.scss'
// ###STYLE_REPLACEMENT_END###

const Toggle = ({ id, label, checked, value, readonly, inversed, size, disabled, onChange, extraClasses }) => {
  const toggleId = id || shortid.generate()
  const [checkStatus, setCheckStatus] = useState(checked)

  const handleChange = () => {
    const newCheckStatus = !checkStatus
    setCheckStatus(newCheckStatus)
    onChange(checkStatus)
  }

  const classes = {
    'gdpp-component': true,
    'fil-toggle-switch': true,
    'fil-toggle-switch--inversed': inversed,
    'fil-toggle-switch--small': size === 'small'
  }

  return (
    <div className={classnames(classes, extraClasses)}>
      <input
        className="fil-toggle-switch__field"
        type="checkbox"
        checked={checkStatus}
        aria-checked={checkStatus}
        disabled={disabled}
        id={toggleId}
        value={value}
        aria-readonly={readonly}
        readOnly={readonly}
        role="switch"
        onChange={handleChange}
      />
      <label className="fil-toggle-switch__label" htmlFor={toggleId} id={`label_${toggleId}`}>
        {label}
      </label>
    </div>
  )
}

Toggle.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  id: PropTypes.string,
  label: PropTypes.string,
  inversed: PropTypes.bool,
  size: PropTypes.oneOf(['standard', 'small']),
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  readonly: PropTypes.bool,
  onChange: PropTypes.func,
  extraClasses: PropTypes.string
}

Toggle.defaultProps = {
  id: '',
  label: '',
  inversed: false,
  size: 'small',
  disabled: false,
  checked: false,
  readonly: false,
  onChange: () => {},
  extraClasses: ''
}

export default Toggle
